
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyDiT9KPM0kug_pZoLCrEk9eKPsFkV7m5-A",
    authDomain: "local-delivery-ea64e.firebaseapp.com",
    databaseURL: "https://local-delivery-ea64e-default-rtdb.firebaseio.com",
    projectId: "local-delivery-ea64e",
    storageBucket: "local-delivery-ea64e.appspot.com",
    messagingSenderId: "478690368650",
    appId: "1:478690368650:web:65bc524ac888d93c2c2173",
    measurementId: "G-2EQYYZ3RGJ"
};

const app = initializeApp(firebaseConfig);
export const fireStore = getDatabase(app);

